import * as React from 'react'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import { Styled } from './styled'
import { sbEditable } from '@storyblok/storyblok-editable'
import { GlobalStyles } from '../../lib/GlobalStyles'

export const Hint = ({ blok }) => {
  return (
    <Styled.Hint {...sbEditable(blok)} className="hint-block prose">
      <GlobalStyles />
      {blok.headline && <Styled.Headline>{blok.headline}</Styled.Headline>}
      <Styled.Content>{renderRichtext(blok.content)}</Styled.Content>
    </Styled.Hint>
  )
}
